import { Fragment } from "react";
import useWindowWidth from "../../hooks/useWindowWidth";
import LazyLoadingImg from "../Components/LazyLoadingImg";

export default function DataSyncs() {
  const width = useWindowWidth();
  return (
    <Fragment>
      <div className="container-fluid horizontal-padding">
        <div className=" a2Features text-center position-relative">
          <div className=" px-lg-6  a2Features text-center position-relative">
            <h2>DATA SYNCS</h2>
          </div>
          <LazyLoadingImg
            src={`/images/${
              width >= 600 ? "DataSync.png" : "DataSyncMobile.png"
            }`}
            alt="a2-portfolio-overview"
            className="mt-md-5 mt-3"
          />
        </div>
      </div>
    </Fragment>
  );
}
